import { FormulierVraag, IFormulierSectie } from "@cak-legacy/klantondersteuning-client";

export class SectieBuilder {
  sectie: IFormulierSectie;

  constructor(titel: string) {
    this.sectie = { titel, vragen: [] };
  }

  addVraag(vraag: string, antwoord: string | string[]): SectieBuilder {
    this.sectie.vragen.push({
      vraag,
      antwoord: antwoord && !Array.isArray(antwoord) ? antwoord : "-",
      antwoorden: Array.isArray(antwoord) ? antwoord : undefined
    });

    return this;
  }

  addVragen(vragen: FormulierVraag[]): SectieBuilder {
    this.sectie.vragen = this.sectie.vragen.concat(vragen);

    return this;
  }
}
